export default "__VITE_ASSET__OZD4sM1b__"